import { apiRequest } from "./apiClient";

export const GetConnectionStatus = async (token, userId) => {
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const params = {
        uid: userId
    };
    if (userId) {
        try {
            return await apiRequest('get', '/algo/demo/data/status', '/api/v2/data/status', {
                headers, params,
            });
        } catch (error) {
            console.log(error.message);
            return error.message;
        }
    }
};